import React from "react";

function Canvas_Shadows() {
  return (
    <div>
      <h1>Canvas_Shadows Component</h1>
      <p>This is the Canvas Shadows tutorial page content.</p>
    </div>
  );
}

export default Canvas_Shadows;
